import { useContext } from 'react';
import { CountryContext } from '~/context/i18n';

export const useLanguageUrl = (): string => {
  const { country, language } = useContext(CountryContext);
  return `/${country.code}/${language}/`;
};
